export const roundToTwoDigits = (num: number) => Math.round(num * 100) / 100

// TODO: check if rounding is required to keep the values accurate.
export const convertToCurrency = (convertToCurrency: number, baseCurrency: number, amount: number) => {
  if (baseCurrency === 0) return 0
  return (convertToCurrency / baseCurrency) * amount
}

export const calculateOwnership = (value: number, ownership: number) => (value * ownership) / 100

export const calculateExpectedMonthlyGrowthFormula = (
  balance: number,
  expectedYield: number,
  managementFee: number,
  monthlyDeposit: number,
  depositFee: number
) => {
  return balance * expectedYield - managementFee / 12 + monthlyDeposit - monthlyDeposit * depositFee
}

export const calculateMonthlyGrowth = ({
  balance,
  expectedYield,
  managementFee,
  monthlyDeposit,
  depositFee,
}: {
  balance: number
  expectedYield: number
  managementFee: number
  monthlyDeposit: number
  depositFee: number
}) => balance * expectedYield - managementFee / 12 + monthlyDeposit - monthlyDeposit * depositFee

export const currentYield = (balance: number, buyingPrice: number, years: number) => {
  if (balance === 0 || years === 0) return 0
  return (balance - buyingPrice) / balance / years
}
